import { createLocalStorage } from '~libs.typescript';
import { createLocalStorageState } from '~libs.ui.react';

export const useWeekendsVisibilityPreference = createLocalStorageState(
   createLocalStorage<boolean>('schedule:preferWeekendsVisible')
);
